import { ProjectResponse } from "../../../types/project";
import { normalizeApiError } from "../../../utils/normalizeApiError";
import axiosInstance from "../../axiosInstance";

export const getProjectsOfUser = async (
  appUserUuid: string,
  page: number = 0,
  size: number = 20,
  search?: string
): Promise<ProjectResponse> => {
  try {
    const { data } = await axiosInstance.get<{ response: ProjectResponse }>(
      `/pmo/project/get-all-projects-of-user/${appUserUuid}`,
      { params: { page, size, search } }
    );
    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
